import { ExtractBaseURL } from "../shared/ExtractBaseURL/ExtractBaseURL";
import { NAVIGATE_TO, BASE_NAME } from "./FileConstants";

const getStartedData = {
  thirdParty: {
    description: `You can test below endpoints to our application <a target="_blank" href="${NAVIGATE_TO.THIRD_PARTY_TEST}">here</a>`,
    // base_url: "https://totalview.healthos.elevancehealth.com",
    patientAccessEndpoints: [
      {
        endpointStep: [
          "To initiate the process, the client application redirects the user to the authorization endpoint. The request includes URL-encoded attributes as a query string component.",
          `Scopes are outlined in the designated <a href="${ExtractBaseURL()}${BASE_NAME}/documentation#scopes-section"> Scopes section. </a>`,
          "The user is redirected to the login page after hitting the authorize URL. After successful login, the user selects member consent and is then directed to the redirect_uri value defined in the authorization request, receiving an authorization code.",
          "Once the user completes the authorization request, they are redirected with the authorization code to the specified redirect_uri. The authorization code is valid for one day and can only be used once, rendering it non-reusable.",
          "We require PKCE (Proof key for code exchange) as an additional level of security, where clients should use code challenge and code verifier as part of their authorization request.",
          "<b> OAuth2 PKCE Flow : </b>",
          "To protect against vulnerable authorization code interception and injection attacks, the PKCE-enhanced Authorization Code Flow is used. It introduces a secret created by the calling application that can be verified by the authorization server; this secret is called the Code Verifier.",
          "Refer to the <a target=\"_blank\" href=\"https://hl7.org/fhir/smart-app-launch/2024Jan/app-launch.html\">SMART-APP-LAUNCH</a> Implementation guide for request and response structure with code_challenge and code_challenge_method.",
          "<b> Steps : <b>",
          "Create code verifier: Generate a code_verifier that will be sent to Auth0 to request tokens.",
          "Create code challenge: Generate a code_challenge from the code_verifier that will be sent to Auth0 to request an authorization_code.",
          "Authorize user: Request the user’s authorization and redirect back to your app with an authorization_code.",
          "Request tokens: Exchange your authorization_code and code_verifier for tokens.",
          "Call API: Use the retrieved Access Token to call your API.",
          "Refresh tokens: Use a Refresh Token to request new tokens when the existing ones expire.",
          "<b> PKCE Parameters : <b>",
          "code_challenge: Generated by the app for the code challenge. When code_challenge_method is 'S256', this is the hashed version of the code_verifier.",
          "code_challenge_method: Method used for the code_challenge parameter. We are using S256.",
          "code_verifier: Used to verify against the code_challenge parameter previously provided in the authorize request.",
        ],
        endpointName: "Authorize",
        request: {
          "curl --request": "GET",
          "--url": {
            path: "{base_url}/oauth2.code/registered/api/v1/authorize",
            parameters: [
              {
                name: "response_type",
              },
              {
                name: "scope",
              },
              {
                name: "client_id",
              },
              {
                name: "redirect_uri",
              },
              {
                name: "aud",
              },
              {
                name: "state",
              },
              {
                name: "code_challenge",
              },
              {
                name: "code_challenge_method",
              },
            ],
          },
          // "--header": "Authorization: Bearer {token}"
          "--response": "{base_url}?code={authorization_code}&state={value}",
        },
      },
      // {
      //   endpointStep: [
      //     "<b> OAuth2 PKCE Flow : </b> The PKCE Flow does not use the client secret key to authenticate. Instead, client application generates the following values to use: ",
      //     "code_verifier - A random cryptographic value to include in the authorization request.",
      //     "code_challenge - A SHA-256 hash of the code_verifier value used in exchange for an access token (Bearer).",
      //     "The Authorization Server stores the code_challenge and uses client application’s authorization request to redirect the user to log in to the application. If successful, the Authorization Server responds and sends your client the authorization code, which is valid for one use.",
      //     "<b>Generate a Code Verifier and a Code Challenge: </b> Generate a code_verifier value in your application and save it. The code_verifier should be a cryptographical value and have a minimum length of 43 characters and a maximum length of 128 characters.",
      //     "<b>Generate the Code Challenge:</b> Generate a code_challenge value in clinet application and save it. The code_challenge value is derived from your code_verifier value. Generate the code_challenge value by using SHA-256 to hash the code_verifier value, then base64 URL encode the results. For example: code_challenge = BASE64URL-ENCODE(SHA256(ASCII(code_verifier)))",
      //   ],
      //   endpointName: "Authorize - with Code Challenge",
      //   request: {
      //     "curl --request": "GET",
      //     "--url": {
      //       path: "{base_url}/oauth2.code/registered/api/v1/authorize",
      //       parameters: [
      //         {
      //           name: "response_type",
      //         },
      //         {
      //           name: "scope",
      //         },
      //         {
      //           name: "client_id",
      //         },
      //         {
      //           name: "redirect_uri",
      //         },
      //         {
      //           name: "aud",
      //         },
      //         {
      //           name: "state",
      //         },
      //         {
      //           name: "code_challenge",
      //         },
      //         {
      //           name: "code_challenge_method",
      //         },
      //       ],
      //     },
      //     // "--header": "Authorization: Bearer {token}"
      //     "--response": "{base_url}?code={authorization_code}&state={value}",
      //   },
      // },
      {
        endpointStep: [
          "<b> For Public Clients : <b>",
        ],
        endpointName: "Access Token",
        request: {
          "curl --request": "POST",
          "--url": {
            path: "{base_url}/client.oauth2/registered/api/v1/token",
          },
          // "--header":
          //   "Authorization: Basic {Base64 ClientId:Secret}, Content-Type: application/x-www-form-urlencoded",
          "--payload":
            "{grant_type=authorization_code code={authorization_code} redirect_uri={redirect_URI} client_id={client_id} code_verifier={code_verifier}}",
          "--response":
            "{access_token:zzz…yyy, token_type:Bearer, expires_in:3600}",
        },
      },
      {
        endpointStep: [
          "<b> For Confidential Clients (Symmetric Authentication) : <b>",
        ],
        endpointName: "Access Token",
        request: {
          "curl --request": "POST",
          "--url": {
            path: "{base_url}/client.oauth2/registered/api/v1/token",
          },
          "--header":
            "Authorization: Basic {Base64 ClientId:Secret}, Content-Type: application/x-www-form-urlencoded",
          "--payload":
            "{grant_type=authorization_code code={authorization_code} redirect_uri={redirect_URI} code_verifier={code_verifier}}",
          "--response":
            "{access_token:zzz…yyy, token_type:Bearer, expires_in:3600}",
        },
      },
      {
        endpointStep: [
          "If a refresh token was requested along with the access token, then the refresh token can be used to request a new access token without having to ask the user to re-authenticate.",
          "If the refresh token is still valid, then a new access token and refresh token will be returned to the user.",
          "If the refresh token has been invalidated for any reason, then the third party application must require the user to re-authenticate to retrieve a new access token.",
          "The reasons for refresh tokens becoming invalid are: Refresh token has expired",
          "A new access token can be requested with a scope of equal or lesser value than the original access token request. Refreshing an access token with additional scopes will return an error. If  the  scope  parameter is  omitted,  then access  token will  be  valid  for  the  original  request scope.",
        ],
        endpointName: "Refresh Token",
        request: {
          "curl --request": "POST",
          "--url": {
            path: "{base_url}/client.oauth2/registered/api/v1/token",
          },
          "--header":
            "Authorization: Basic {Base64 ClientId:Secret}, Content-Type: application/x-www-form-urlencoded",
          "--payload":
            "{grant_type=refresh_token refresh_token={refresh_token}}",
          "--response":
            "{access_token:zzz…yyy, token_type:Bearer, expires_in:7776000}",
        },
      },
      {
        endpointStep: [
          "To retrieve data for a member or patient, you can query the Patient resource for a unique patient identifier.",
        ],
        endpointName: "FHIR",
        request: {
          "curl --request": "GET",
          "--url": {
            path: "{{base_url}}/resources/registered/{brand_name}/api/v1/fhir/Patient/{patient_resource_id}",
          },
          "--header":
            "Authorization: Bearer {access_token}, Content-Type: application/json",
          "--response":
            "{resourceType: Patient,id: {patient_resource_id},meta: {patient_details},...}",
        },
      },
    ],
  },
  payer: {
    description: `You can test below endpoints to our application <a target="_blank" href="${NAVIGATE_TO.THIRD_PARTY_TEST}">here</a>`,
    // base_url: "https://totalview.healthos.elevancehealth.com",
    patientAccessEndpoints: [
      {
        endpointStep: [
          "To initiate the process, the client application redirects the user to the authorization endpoint. The request includes URL-encoded attributes as a query string component.",
          `Scopes are outlined in the designated <a href="${ExtractBaseURL()}${BASE_NAME}/documentation#scopes-section"> Scopes section </a>`,
          "The user is redirected to the login page after hitting the authorize URL. After successful login, the user selects member consent and is then directed to the redirect_uri value defined in the authorization request, receiving an authorization code.",
          "Once the user completes the authorization request, they are redirected with the authorization code to the specified redirect_uri. ",
          "The authorization code is valid for one day and can only be used once, rendering it non-reusable.",
        ],
        endpointName: "Authorize",
        request: {
          "curl --request": "GET",
          "--url": {
            path: "{base_url}/oauth2.code/registered/api/v1/authorize",
            parameters: [
              {
                name: "response_type",
              },
              {
                name: "scope",
              },
              {
                name: "client_id",
              },
              {
                name: "redirect_uri",
              },
              {
                name: "aud",
              },
              {
                name: "state",
              },
            ],
          },
          // "--header": "Authorization: Bearer {token}"
          "--response": "{base_url}?code={authorization_code}&state={value}",
        },
      },
      {
        endpointStep: [
          "The user must exchange the authorization code obtained in the previous step for an access token, enabling authorization to FHIR resources.",
          "The token response varies based on the scope provided to the authorize API scope parameter. The access token has a 60-minute expiration time. If the access token expires, the refresh token API must be invoked to retrieve it, as the refresh token itself has a 90-day expiration time.",
        ],
        endpointName: "Access Token",
        request: {
          "curl --request": "POST",
          "--url": {
            path: "{base_url}/client.oauth2/registered/api/v1/token",
          },
          "--header":
            "Authorization: Basic {Base64 ClientId:Secret}, Content-Type: application/x-www-form-urlencoded",
          "--payload":
            "{grant_type=authorization_code code={authorization_code} redirect_uri={redirect_URI}}",
          "--response":
            "{access_token:zzz…yyy, token_type:Bearer, expires_in:3600}",
        },
      },
      {
        endpointStep: [
          "If a refresh token was requested along with the access token, then the refresh token can be used to request a new access token without having to ask the user to re-authenticate.",
          "If the refresh token is still valid, then a new access token and refresh token will be returned to the user.",
          "If the refresh token has been invalidated for any reason, then the user must require the user to re-authenticate to retrieve a new access token.",
          "The reasons for refresh tokens becoming invalid are: Refresh token has expired",
          "A new access token can be requested with a scope of equal or lesser value than the original access token request. Refreshing an access token with additional scopes will return an error. If  the  scope  parameter is  omitted,  then access  token will  be  valid  for  the  original  request scope.",
        ],
        endpointName: "Refresh Token",
        request: {
          "curl --request": "POST",
          "--url": {
            path: "{base_url}/client.oauth2/registered/api/v1/token",
          },
          "--header":
            "Authorization: Basic {Base64 ClientId:Secret}, Content-Type: application/x-www-form-urlencoded",
          "--payload":
            "{grant_type=refresh_token refresh_token={refresh_token}}",
          "--response":
            "{access_token:zzz…yyy, token_type:Bearer, expires_in:7776000}",
        },
      },
      {
        endpointStep: [
          "To retrieve data for a member or patient, you can query the Patient resource for a unique patient identifier.",
        ],
        endpointName: "FHIR",
        request: {
          "curl --request": "GET",
          "--url": {
            path: "{{base_url}}/resources/registered/{brand_name}/api/v1/fhir/Patient/{patient_resource_id}",
          },
          "--header":
            "Authorization: Bearer {access_token}, Content-Type: application/json",
          "--response":
            "{resourceType: Patient,id: {patient_resource_id},meta: {patient_details},extension: {patient_details},identifier: {patient_details},name: {patient_details},telecom: {patient_details},gender: {patient_details},birthDate: {patient_details},communication: {patient_details}}",
        },
      },
    ],
    pdexAccessEndpoints: [
      {
        endpointStep: [
          "The user will receive a response to this request. If successful, a 200 OK response will be received and the access token will be returned in a JSON structure. A refresh token will NOT be returned to the client.",
        ],
        endpointName: "Member Match Token",
        request: {
          "curl --request": "POST",
          "--url": {
            path: "{base_url}/client.oauth2/unregistered/api/v1/token",
          },
          "--header":
            "Authorization: Basic {Base64 ClientId:Secret}, Content-Type: application/x-www-form-urlencoded",
          "--payload": "{grant_type=client_credentials}",
          "--response":
            "{access_token:zzz…yyy, token_type:Bearer, expires_in:3600}",
        },
      },
      {
        endpointStep: [
          "To access information about a member on a payer’s system, the requesting system needs to know the unique identifier of that member on the payer’s system",
          "The $member-match operation supports identifying the target payer’s member and coverage information for a specified member so the client can use that information for subsequent queries and operations.",
          "The operation works by passing in three sets of information:",
          `The requesting payer’s demographic information on the member (as a Patient resource)
                    The requesting payer’s Coverage information (as justification/support for the matching request)
                    The target payer’s Coverage information (as gleaned from the member’s card)`,
        ],
        endpointName: "Member Match",
        request: {
          "curl --request": "POST",
          "--url": {
            path: "{base_url}/resources/unregistered/api/v1/fhir/Patient/$member-match",
          },
          "--header":
            "Authorization: Bearer {access_token}, Content-Type: application/json",
          "--payload": `{
                        "resourceType": "Parameters",
                        "id": "member-match-in",
                        "parameter": [
                            {
                                "name": "MemberPatient",
                                "resource": {
                                    "resourceType": "Patient",
                                    "id": {value},
                                    "identifier": [
                                    ],
                                    "name": {value},
                                    "gender": {value},
                                    "birthDate": {value}
                                }
                            }
                        ]
                    }`,
          "--response": `{
                        "resourceType" : "Parameters",
                        "id" : "member-match-out",
                        "parameter" : [
                          {
                            "name" : "MemberIdentifier",
                            "valueIdentifier" : {
                              "type" : {
                                "coding" : 
                              },
                              "system" : "http://example.org/target-payer/identifiers/member",
                              "value" : {patient_resource_id},
                              "assigner" : {
                                "display" : "Elevance Health"
                              }
                           }
                          }
                        ]
                      }`,
        },
      },

      {
        endpointStep: [
          "The user will receive a response to this request. If successful, a 200 OK response will be received and the access token will be returned in a JSON structure. A refresh token will NOT be returned to the client.",
        ],
        endpointName: "FHIR Token",
        request: {
          "curl --request": "POST",
          "--url": {
            path: "{base_url}/client.oauth2/unregistered/api/v1/token",
          },
          "--header":
            "Authorization: Basic {Base64 ClientId:Secret}, Content-Type: application/x-www-form-urlencoded",
          "--payload":
            "{grant_type=client_credentials, member_id={patient_resource_id}}",
          "--response":
            "{access_token:zzz…yyy, token_type:Bearer, expires_in:3600}",
        },
      },
      {
        endpointStep: [
          "To retrieve data for a member or patient, you can query the Patient resource for a unique patient identifier.",
        ],
        endpointName: "FHIR",
        request: {
          "curl --request": "GET",
          "--url": {
            path: "{{base_url}}/resources/registered/{brand_name}/api/v1/fhir/Patient/{patient_resource_id}",
          },
          "--header":
            "Authorization: Bearer {access_token}, Content-Type: application/json",
          "--response":
            "{resourceType: Patient,id: {patient_resource_id},meta: {patient_details},extension: {patient_details},identifier: {patient_details},name: {patient_details},telecom: {patient_details},gender: {patient_details},birthDate: {patient_details},communication: {patient_details}}",
        },
      },
    ],
  },
  sandbox: {
    description: `You can test below endpoints to our application <a target="_blank" href="${NAVIGATE_TO.THIRD_PARTY_TEST}">here</a>`,
    //base_url: "https://totalview.healthos.elevancehealth.com",
    patientAccessEndpoints: [
      {
        endpointStep: [
          "To initiate the process, the client application redirects the user to the authorization endpoint. The request includes URL-encoded attributes as a query string component.",
          `Scopes are outlined in the designated <a href="${ExtractBaseURL()}${BASE_NAME}/documentation#scopes-section"> Scopes section </a>`,
          "The user is redirected to the login page after hitting the authorize URL. After successful login, the user selects member consent and is then directed to the redirect_uri value defined in the authorization request, receiving an authorization code.",
          "Once the user completes the authorization request, they are redirected with the authorization code to the specified redirect_uri. ",
          "The authorization code is valid for one day and can only be used once, rendering it non-reusable.",
        ],
        endpointName: "Authorize",
        request: {
          "curl --request": "GET",
          "--url": {
            path: "{base_url}/oauth2.code/registered/api/v1/authorize",
            parameters: [
              {
                name: "response_type",
              },
              {
                name: "scope",
              },
              {
                name: "client_id",
              },
              {
                name: "redirect_uri",
              },
              {
                name: "aud",
              },
              {
                name: "state",
              },
            ],
          },
          // "--header": "Authorization: Bearer {token}"
          "--response": "{base_url}?code={authorization_code}&state={value}",
        },
      },
      {
        endpointStep: [
          "The user must exchange the authorization code obtained in the previous step for an access token, enabling authorization to FHIR resources.",
          "The token response varies based on the scope provided to the authorize API scope parameter. The access token has a 60-minute expiration time. If the access token expires, the refresh token API must be invoked to retrieve it, as the refresh token itself has a 90-day expiration time.",
        ],
        endpointName: "Access Token",
        request: {
          "curl --request": "POST",
          "--url": {
            path: "{base_url}/client.oauth2/registered/api/v1/token",
          },
          "--header":
            "Authorization: Basic {Base64 ClientId:Secret}, Content-Type: application/x-www-form-urlencoded",
          "--payload":
            "{grant_type=authorization_code code={authorization_code} redirect_uri={redirect_URI}}",
          "--response":
            "{access_token:zzz…yyy, token_type:Bearer, expires_in:3600}",
        },
      },
      {
        endpointStep: [
          "If a refresh token was requested along with the access token, then the refresh token can be used to request a new access token without having to ask the user to re-authenticate.",
          "If the refresh token is still valid, then a new access token and refresh token will be returned to the user.",
          "If the refresh token has been invalidated for any reason, then the user must require the user to re-authenticate to retrieve a new access token.",
          "The reasons for refresh tokens becoming invalid are: Refresh token has expired",
          "A new access token can be requested with a scope of equal or lesser value than the original access token request. Refreshing an access token with additional scopes will return an error. If  the  scope  parameter is  omitted,  then access  token will  be  valid  for  the  original  request scope.",
        ],
        endpointName: "Refresh Token",
        request: {
          "curl --request": "POST",
          "--url": {
            path: "{base_url}/client.oauth2/registered/api/v1/token",
          },
          "--header":
            "Authorization: Basic {Base64 ClientId:Secret}, Content-Type: application/x-www-form-urlencoded",
          "--payload":
            "{grant_type=refresh_token refresh_token={refresh_token}}",
          "--response":
            "{access_token:zzz…yyy, token_type:Bearer, expires_in:7776000}",
        },
      },
      {
        endpointStep: [
          "To retrieve data for a member or patient, you can query the Patient resource for a unique patient identifier.",
        ],
        endpointName: "FHIR",
        request: {
          "curl --request": "GET",
          "--url": {
            path: "{{base_url}}/resources/registered/{brand_name}/api/v1/fhir/Patient/{patient_resource_id}",
          },
          "--header":
            "Authorization: Bearer {access_token}, Content-Type: application/json",
          "--response":
            "{resourceType: Patient,id: {patient_resource_id},meta: {patient_details},extension: {patient_details},identifier: {patient_details},name: {patient_details},telecom: {patient_details},gender: {patient_details},birthDate: {patient_details},communication: {patient_details}}",
        },
      },
    ],
  },
  provider: {
    description: `You can test below endpoints to our application <a target="_blank" href="${NAVIGATE_TO.THIRD_PARTY_TEST}">here</a>`,
    // base_url: "https://totalview.healthos.elevancehealth.com",
    pdexAccessEndpoints: [
      {
        endpointStep: [
          "The user will receive a response to this request. If successful, a 200 OK response will be received and the access token will be returned in a JSON structure. A refresh token will NOT be returned to the client.",
        ],
        endpointName: "Member Match Token",
        request: {
          "curl --request": "POST",
          "--url": {
            path: "{base_url}/client.oauth2/unregistered/api/v1/token",
          },
          "--header":
            "Authorization: Basic {Base64 ClientId:Secret}, Content-Type: application/x-www-form-urlencoded",
          "--payload": "{grant_type=client_credentials}",
          "--response":
            "{access_token:zzz…yyy, token_type:Bearer, expires_in:3600}",
        },
      },
      {
        endpointStep: [
          "To access information about a member on a payer’s system, the requesting system needs to know the unique identifier of that member on the payer’s system",
          "The $member-match operation supports identifying the target payer’s member and coverage information for a specified member so the client can use that information for subsequent queries and operations.",
          "The operation works by passing in three sets of information:",
          `The requesting payer’s demographic information on the member (as a Patient resource)
                    The requesting payer’s Coverage information (as justification/support for the matching request)
                    The target payer’s Coverage information (as gleaned from the member’s card)`,
        ],
        endpointName: "Member Match",
        request: {
          "curl --request": "POST",
          "--url": {
            path: "{base_url}/resources/unregistered/api/v1/fhir/Patient/$member-match",
          },
          "--header":
            "Authorization: Bearer {access_token}, Content-Type: application/json",
          "--payload": `{
                        "resourceType": "Parameters",
                        "id": "member-match-in",
                        "parameter": [
                            {
                                "name": "MemberPatient",
                                "resource": {
                                    "resourceType": "Patient",
                                     "id": {value},
                                    "identifier": [
                                    ],
                                    "name": {value},
                                    "gender": {value},
                                    "birthDate": {value},
                                    "address": {value}
                                }
                            }
                        ]
                    }`,
          "--response": `{
                        "resourceType" : "Parameters",
                        "id" : "member-match-out",
                        "parameter" : [
                          {
                            "name" : "MemberIdentifier",
                            "valueIdentifier" : {
                              "type" : {
                                "coding" : 
                              },
                              "system" : "http://example.org/target-payer/identifiers/member",
                              "value" : {patient_resource_id},
                              "assigner" : {
                                "display" : "Elevance Health"
                              }
                           }
                          }
                        ]
                      }`,
        },
        // endpointStep: [
        //   "NOTE: If you have the any other id other than the hcid, please contact with elevance health team to understand the payload.",
        // ],
      },
      {
        endpointStep: [
          "To access information about a member on a payer’s system, the requesting system needs to know the unique identifier of that member on the payer’s system.",
          "The identifier, until unless advised should be the unique member id present on member’s Healthcare id. Some of the entities can use an Elevance internal identifier called MCID, based upon the specific arrangement Elevance have with the entity requesting the data. Please see the structure of the identifiers in the below Sample. The identifier type reflecting um will capture the MCID as the identifier and the identifier type reflecting MB will capture the healthcare identifier of the member.",
        ],
        endpointName: "Member Match with ID",
        request: {
          "curl --request": "POST",
          "--url": {
            path: "{base_url}/resources/unregistered/api/v1/fhir/Patient/$member-match",
          },
          "--header":
            "Authorization: Bearer {access_token}, Content-Type: application/json",
          "--payload": `{
                        "resourceType": "Parameters",
                        "id": "member-match-in",
                        "parameter": [
                            {
                                "name": "MemberPatient",
                                "resource": {
                                    "resourceType": "Patient",
                                    "id": {value},
                                    "identifier": [
                                      {
                                          "type": {
                                              "coding": [
                                                  {
                                                      "system": "http://terminology.hl7.org/CodeSystem/v2-0203",
                                                      "code": "MB"
                                                  }
                                              ]
                                          },
                                          "system": "urn:oid:1.2.36.146.595.217.0.1",
                                          "value": "55678",
                                          "assigner": {
                                              "display": "Old Payer"
                                          }
                                      },
                                      {
                                          "type": {
                                              "coding": [
                                                  {
                                                      "system": "http://hl7.org/fhir/us/carin-bb/CodeSystem/c4bbidentifiertype",
                                                      "code": "um"
                                                  }
                                              ]
                                          },
                                          "system": "https://elevancehealth.com/cdl/mcid",
                                          "value": "ABCDEF"
                                      }
                                  ]
                            
                                    "name": {value},
                                    "gender": {value},
                                    "birthDate": {value},
                                    "address": {value}
                                }
                            }
                        ]
                    }`,
          "--response": `{
                        "resourceType" : "Parameters",
                        "id" : "member-match-out",
                        "parameter" : [
                          {
                            "name" : "MemberIdentifier",
                            "valueIdentifier" : {
                              "type" : {
                                "coding" :
                              },
                              "system" : "http://example.org/target-payer/identifiers/member",
                              "value" : {patient_resource_id},
                              "assigner" : {
                                "display" : "Elevance Health"
                              }
                           }
                          }
                        ]
                      }`,
        },
      },
      {
        endpointStep: [
          "The user will receive a response to this request. If successful, a 200 OK response will be received and the access token will be returned in a JSON structure. A refresh token will NOT be returned to the client.",
        ],
        endpointName: "FHIR Token",
        request: {
          "curl --request": "POST",
          "--url": {
            path: "{base_url}/client.oauth2/unregistered/api/v1/token",
          },
          "--header":
            "Authorization: Basic {Base64 ClientId:Secret}, Content-Type: application/x-www-form-urlencoded",
          "--payload":
            "{grant_type=client_credentials, member_id={patient_resource_id}}",
          "--response":
            "{access_token:zzz…yyy, token_type:Bearer, expires_in:3600}",
        },
      },
      {
        endpointStep: [
          "To retrieve data for a member or patient, you can query the Patient resource for a unique patient identifier.",
        ],
        endpointName: "FHIR",
        request: {
          "curl --request": "GET",
          "--url": {
            path: "{{base_url}}/resources/registered/{brand_name}/api/v1/fhir/Patient/{patient_resource_id}",
          },
          "--header":
            "Authorization: Bearer {access_token}, Content-Type: application/json",
          "--response":
            "{resourceType: Patient,id: {patient_resource_id},meta: {patient_details},extension: {patient_details},identifier: {patient_details},name: {patient_details},telecom: {patient_details},gender: {patient_details},birthDate: {patient_details},communication: {patient_details}}",
        },
      },
    ],
  },
};

export default getStartedData;

// provider: {
//     base_url : "https://totalview.healthos.elevancehealth.com",
//     pdexAccessEndpoints : [
//         {
//             endpointStep: "Use the token end point to receive the token for member match operation",
//             request: {
//                 endpointName: "Token",
//                 action: "Get",
//                 path: "{base_url}/client.oauth2/unregistered/api/v1/token",
//                 description: "Token"
//             }
//         },
//         {
//             endpointStep: "Use the member match end point to perform member match",
//             request: {
//                 endpointName: "Member Match",
//                 action: "Get",
//                 path: "{base_url}resources/unregistered/api/v1/fhir/Patient/$member-match",
//                 description: "Member Match"
//             }
//         },
//         {
//             endpointStep:"Use the member match id to get the access token for FHIR data",
//             request: {
//                 endpointName: "Token",
//                 action: "Get",
//                 path: "{base_url}/client.oauth2/unregistered/api/v1/token",
//                 description: "Token"
//             }
//         },
//         {
//             endpointStep:"Access FHIR resources",
//             request: {
//                 endpointName: "FHIR",
//                 action: "Get",
//                 path: "{base_url}resources/unregistered/api/v1/fhir",
//                 description: "FHIR"
//             }
//         },

//     ]
// },
// payer : {
//     base_url: "https://totalview.healthos.elevancehealth.com",
//     patientAccessEndpoints: [
//         {
//             endpointStep: "Use authentication to access our API. After successful authentication, Use authorize endpoint to retreive auth code",
//             request: {
//                 endpointName: "Authorize",
//                 action: "Get",
//                 path: "{base_url}/oauth2.code/registered/api/v1/authorize",
//                 payload: "{base_url}/oauth2.code/registered/api/v1/authorize?response_type={value}&scope={value}&client_id={value}&redirect_uri={value}&aud={value}&state={value}",
//                 description: "Authorization"
//             }
//         },
//         {
//             endpointStep:"Use the authorization code to receive the access token",
//             request: {
//                 endpointName: "Access Token",
//                 action: "Get",
//                 path: "{base_url}/client.oauth2/registered/api/v1/token",
//                 description: "Access Token"
//             }
//         },
//         {
//             endpointStep:"Use the refresh token to receive the access token",
//             request: {
//                 endpointName: "Refresh Token",
//                 action: "Get",
//                 path: "{base_url}/client.oauth2/registered/api/v1/token",
//                 description: "Refresh Token"
//             }
//         },
//         {
//             endpointStep: "Use the access token to access FHIR resources",
//             request: {
//                 endpointName: "FHIR",
//                 action: "Get",
//                 path: "{base_url}/resources/registered/{brand}/api/v1/fhir",
//                 description: "FHIR"
//             }
//         },
//     ],
//     pdexAccessEndpoints : [
//         {
//             endpointStep: "Use the token end point to receive the token for member match operation",
//             request: {
//                 endpointName: "Token",
//                 action: "Get",
//                 path: "{base_url}/client.oauth2/unregistered/api/v1/token",
//                 description: "Token"
//             }
//         },
//         {
//             endpointStep: "Use the member match end point to perform member match",
//             request: {
//                 endpointName: "Member Match",
//                 action: "Get",
//                 path: "{base_url}resources/unregistered/api/v1/fhir/Patient/$member-match",
//                 description: "Member Match"
//             }
//         },
//         {
//             endpointStep:"Use the member match id to get the access token for FHIR data",
//             request: {
//                 endpointName: "Token",
//                 action: "Get",
//                 path: "{base_url}/client.oauth2/unregistered/api/v1/token",
//                 description: "Token"
//             }
//         },
//         {
//             endpointStep:"Access FHIR resources",
//             request: {
//                 endpointName: "FHIR",
//                 action: "Get",
//                 path: "{base_url}resources/unregistered/api/v1/fhir",
//                 description: "FHIR"
//             }
//         },

//     ]
// },
// thirdParty: {
//     description: `You can test below endpoints to our application <a target="_blank" href="${NAVIGATE_TO.THIRD_PARTY_TEST}">here</a>`,
//     base_url: "https://totalview.healthos.elevancehealth.com",
//     patientAccessEndpoints: [
//         {
//             endpointStep: "Use authentication to access our API. After successful authentication, Use authorize endpoint to retreive auth code",
//             endpointName: "Authorize",
//             request: {
//                 endpointName: "Authorize",
//                 request: "Get",
//                 url: "{base_url}/oauth2.code/registered/api/v1/authorize",
//                 parameters:[
//                     {
//                         name: "response_type",
//                     },
//                     {
//                         name: "scope",
//                     },
//                     {
//                         name: "client_id",
//                     },
//                     {
//                         name: "redirect_uri",
//                     },
//                     {
//                         name: "aud",
//                     },
//                     {
//                         name: "state",
//                     },
//                 ],
//             }
//         },
//         {
//             endpointStep:"Use the authorization code to receive the access token",
//             request: {
//                 endpointName: "Access Token",
//                 action: "Get",
//                 path: "{base_url}/client.oauth2/registered/api/v1/token",
//                 description: "Access Token"
//             }
//         },
//         {
//             endpointStep:"Use the refresh token to receive the access token",
//             request: {
//                 endpointName: "Refresh Token",
//                 action: "Get",
//                 path: "{base_url}/client.oauth2/registered/api/v1/token",
//                 description: "Refresh Token"
//             }
//         },
//         {
//             endpointStep: "Use the access token to access FHIR resources",
//             request: {
//                 endpointName: "FHIR",
//                 action: "Get",
//                 path: "{base_url}/resources/registered/{brand}/api/v1/fhir",
//                 description: "FHIR"
//             }
//         },
//     ],
